<template>
  <div class="py-4 container-fluid">
    <ToastPrime position="bottom-left" />
    <div class="card">
      <div class="card-header py-3">
        <div class="row align-items-center">
          <!-- Bagian H3 di Kiri -->
          <div class="col-4">
            <h5 class="mb-0">Query Template</h5>
          </div>

          <!-- Bagian Pencarian di Tengah -->
          <div class="col-4 d-flex justify-content-center">
            <IconField class="w-100">
              <InputIcon class="pi pi-search" />
              <InputText
v-model="table.search" type="text" size="small" placeholder="Search Description"
                class="rounded-pill w-100" @keyup="filter" />
            </IconField>
          </div>

          <!-- Bagian Button di Kanan -->
          <div class="col-4 text-end">
            <button type="button" class="mx-1 mb-0 btn btn-sm btn-primary" @click="openAddModal">Add</button>
          </div>
        </div>
      </div>
      <div style="height: 500px; overflow-y: auto">
        <DataTable :value="table.data" removable-sort scrollable scroll-height="flex" table-style="min-width: 75rem">
          <Column header="Code" header-class="bg-light">
            <template #body="row">
              <Skeleton v-if="table.onLoad" />
              <span v-else>{{ row.data.code }}</span>
            </template>
          </Column>
          <Column header="Description" header-class="bg-light" sortable>
            <template #body="row">
              <Skeleton v-if="table.onLoad" />
              <span v-else>{{ row.data.description }}</span>
            </template>
          </Column>
          <Column header="Action" header-class="bg-light">
            <template #body="row">
              <Skeleton v-if="table.onLoad" />
              <span v-else>{{ row.data.action }}</span>
            </template>
          </Column>
          <Column :style="{ width: '100px' }" :body-style="{ width: '100px', padding: '0' }" header-class="bg-light">
            <template #body="row">
              <div v-if="!table.onLoad">
                <ButtonPrime
v-tooltip.bottom="'Update'" icon="pi pi-pencil" outlined rounded size="small"
                  @click="openEditModal(row.data)" />
                <ButtonPrime
v-tooltip.bottom="'Delete'" icon="pi pi-trash" outlined rounded severity="danger"
                  size="small" style="margin-left: 5px;" @click="deleteItem(row.data.id)" />
              </div>
              <div v-else class="m-4"><span /></div>
            </template>
          </Column>
          <template #empty>
            <div style="text-align: center; padding: 35px 0;">
              <img src="/no_data.png" alt="No Data" style="width: 330px; height: 330px; opacity: 0.7;" />
              <p class="text-muted mt-2">No Data</p>
            </div>
          </template>
        </DataTable>
      </div>
      <div class="card-footer pb-0 d-flex justify-content-between align-items-center">
        <BasePagination
v-model="table.page.current_page" :page-count="table.page.total_page" size="sm"
          @click="changePage()" />
        <p>
          {{ (table.page.current_page - 1) * table.page.per_page + table.data.length }}
          of {{ table.total }}
        </p>
      </div>
    </div>

    <DialogPrime v-model:visible="modal.visible" :header="modal.title" style="width: 30rem; margin: 10px;">
      <div class="mb-2">
        <label for="code" class="font-semibold">Code <span class="text-danger">*</span></label>
        <InputText
id="code" v-model="modal.data.code" placeholder="Code"
          :class="`${(modal.errorMessage['code'] && modal.data.code == '') ? 'border-danger' : ''}`"
          fluid :disabled="modal.action === 'edit'" @input="toUpperCaseVal($event, 'code')" />
        <small v-if="modal.errorMessage['code'] && modal.data.code == ''" class="text-danger">{{
          modal.errorMessage['code']
        }}</small>
      </div>

      <div class="mb-2">
        <label for="description" class="font-semibold">Description <span class="text-danger">*</span></label>
        <InputText
id="description" v-model="modal.data.description" placeholder="Description"
          :class="`${(modal.errorMessage['description'] && modal.data.description == '') ? 'border-danger' : ''}`"
          fluid />
        <small v-if="modal.errorMessage['description'] && modal.data.description == ''" class="text-danger">{{
          modal.errorMessage['description'] }}</small>
      </div>

      <div class="">
        <label for="action" class="font-semibold">Action <span class="text-danger">*</span></label>
        <InputText
id="action" v-model="modal.data.action" placeholder="action"
          :class="`${(modal.errorMessage['action'] && modal.data.action == '') ? 'border-danger' : ''}`" fluid />
        <small v-if="modal.errorMessage['action'] && modal.data.action == ''" class="text-danger">{{
          modal.errorMessage['action'] }}</small>
      </div>

      <template #footer>
        <div class="d-flex justify-content-end gap-2 pt-3 border-top w-100 mt-2 px-1">
          <ButtonPrime
type="button" label="Cancel" severity="danger" class="px-4 border-0" raised size="small"
            :disabled="modal.onLoading" @click="modal.visible = false" />
          <ButtonPrime
type="button" severity="contrast" raised size="small" label="Save" class="px-4" :disabled="modal.onLoading || anyEmptyVal"
            @click="save()">
            <template v-if="modal.onLoading" #icon>
              <i class="fas fa-spinner fa-spin me-2"></i>
            </template>
          </ButtonPrime>
        </div>
      </template>
    </DialogPrime>
  </div>
</template>

<script>
import api from "@/helpers/api";
import queryTemplateService from "@/services/generalSettings/queryTemplateService"

export default {
  data() {
    return {
      table: {
        search: this.$route.query.description || "",
        onLoad: false,
        total: 3,
        data: [{}],
        page: {
          current_page: 1,
          total_page: 1,
        },
        limit: 100,
      },
      modal: {
        visible: false,
        action: "",
        title: "",
        data: {},
        errorMessage: {},
        onLoading: false,
      },
    };
  },
  computed: {
    anyEmptyVal() {
      return (!this.modal.data.code || !this.modal.data.description || !this.modal.data.action);
    }
  },
  mounted() {
    this.get()
  },
  methods: {
    async get() {
      this.table.onLoad = true
      try {
        const response = await api(this, queryTemplateService.list({ limit: this.table.limit, page: this.table.page.current_page, description: this.table.search }), false);

        this.table.data = response.data.data;
        this.table.total = response.data.total;
        this.table.page = response.data;
        this.table.page.total_page = response.data.last_page
        // console.log("page", this.table.page);
      } catch (error) {
        this.table.data = []
        this.table.total = 0
      } finally {
        this.table.onLoad = false
      }
    },
    openAddModal() {
      this.modal = {
        visible: true,
        action: "create",
        title: "Add Query Template",
        data: { code: "", description: "", action: "" },
        errorMessage: {},
        onLoading: false,
      }
    },
    openEditModal(item) {
      this.modal = {
        visible: true,
        action: "edit",
        title: "Edit Query Template",
        data: { ...item },
        errorMessage: {},
        onLoading: false,
      };
    },
    deleteItem(id) {
      this.confirmDialog("You won't be able to revert this!", "delete it").then((result) => {
        if (result.isConfirmed) {
          this.table.onLoad = true
          api(this, queryTemplateService.delete(id)).then(() => { this.get() });
        }
      });
    },
    save() {
      let isValid = true;
      const requiredField = [{ key: "code", message: "Code" }, { key: "description", message: "Description" }, { key: "action", message: "Action" }];
      requiredField.forEach((val) => {
        if (!this.modal.data[val.key]) {
          this.modal.errorMessage[val.key] = `${val.message} is required`;
          isValid = false;
        }
      })
      if (!isValid) return false;

      this.modal.onLoading = true
      setTimeout(async () => {
        try {
          if (this.modal.action === 'create') {
            await api(this, queryTemplateService.create(this.modal.data));
          } else if (this.modal.action === 'edit') {
            await api(this, queryTemplateService.update(this.modal.data.id, this.modal.data))
          }
          this.modal.data = {};
          this.modal.visible = false;
          this.get();
        } catch (error) {
          this.handleErrorObjectNested(error)
        } finally {
          this.modal.onLoading = false
        }
      }, 500)
    },
    filter() {
      if (this.table.search != this.$route.query.description) {
        setTimeout(() => {
          if (this.table.search.length > 3) {
            this.table.search = this.table.search.toUpperCase()
            this.$router.push({ name: 'Query Templates', params: { moduleSlug: 'material-management' }, query: { description: this.table.search }, });
          } else {
            this.$router.push({ name: 'Query Templates', params: { moduleSlug: 'material-management' } });
          }

          this.get();
        }, 500)
      }
    },
    changePage() {
      this.table.onLoad = true;
      setTimeout(() => {
        this.get();
      }, 100);
    },
    toUpperCaseVal(event, key) {
      const input = event.target;
      const start = input.selectionStart;
      const end = input.selectionEnd;

      const upper = input.value.toUpperCase();
      this.modal.data[key] = upper;

      this.$nextTick(() => {
        input.setSelectionRange(start, end);
      });
    },
    handleErrorObjectNested(error) {
      if (error.response?.data?.code == 400 || error.response?.status == 422 || error.response?.status == 500) {
        const errorData = error.response?.data?.data;

        if (typeof errorData === 'object' && errorData !== null) {
          for (const key in errorData) {
            if (Object.prototype.hasOwnProperty.call(errorData, key)) {
              const match = key.match(/^items\.(\d+)\.(.+)$/);
              if (match) {
                error.response.data.data[key].forEach(message => {
                  this.$toastNotifPrime('error', error.response.data.message, `${message} in row ${parseInt(match[1]) + 1}`)
                })
              } else {
                this.$toastNotifPrime('error', error.response.data.message, errorData[key]);
                // errorData[key].forEach(message => {
                //   this.$toastNotifPrime('error', error.response.data.message, message);
                // });
              }
            }
          }
        }
      }
    },
  },
};
</script>
